<template xmlns:white-space="">
    <el-container>
        <el-header class="biaoTop">
            <el-image
                    :src="require('../img2/Headlogo.png')"
                     class="imgTop"></el-image>
        </el-header>
        <el-header class="headSsinput">
            <div class="clfInput">
                <el-row>
                    <el-col :span="6">
                        <el-input placeholder="请输入项目名称"  v-model="xmmc"  class="ssInput"></el-input>
                    </el-col>
                    <el-col :span="4" class="HeadLog">
                        <el-image  @click="openByXmmc()"
                                :src="require('../img2/clf/ssicon.png')"
                        ></el-image>
                    </el-col>
                </el-row>
            </div>
        </el-header>
        <el-header>
            <div style="text-align: center">
                <el-menu
                        class="el-menu-demo"
                        mode="horizontal"
                        :default-active="activeIndex"
                        background-color="#00448C"
                        text-color="white"
                        align="center"
                        router
                        white-space:no-wrap
                        active-text-color="white">
                    <el-menu-item class="el-li"  index="/home/index">首页</el-menu-item>
                    <el-menu-item @click="menuClick('/ywhome/spfhome')" class="el-li"  index="/ywhome/spfhome">商品房</el-menu-item>
                    <el-menu-item @click="menuClick('/ywhome/clfhome')" class="el-li"  index="/ywhome/clfhome" >存量房</el-menu-item>
                    <el-menu-item @click="WarnMessageZl()" class="el-li"  index="">租赁房</el-menu-item>
                    <el-menu-item @click="menuClick('/ywhome/jjglhome')" class="el-li"  index="/ywhome/jjglhome">经纪管理</el-menu-item>
                    <el-menu-item @click="menuClick('/ywhome/xxcxhome')" class="el-li"  index="/ywhome/xxcxhome">信息查询</el-menu-item>
                    <el-menu-item @click="menuClick('/ywhome/zcfghome')" class="el-li"  index="/ywhome/zcfghome">政策法规</el-menu-item>
                    <el-menu-item @click="menuClick('/ywhome/bgxzhome')" class="el-li"  index="/ywhome/bgxzhome">表格下载</el-menu-item>
                </el-menu>
            </div>
        </el-header>
        <el-header v-show="sfxs_test">
            <test></test>
        </el-header>
        <div class="mainRoute">
            <router-view></router-view>
        </div>
        <el-footer height="200px" class="YeJiao">
            <p  class="footClass">Copyright 2021-2031 www.hzfjw.com. All Rights Reserved.<br>
                主管部门：汉中市住房和城乡建设局 管理维护：汉中市房产交易管理所（汉中市房产交易中心）<br>
                联系地址：汉中市汉台区荔枝路房产大厦三楼
            </p>
            <el-row>
                    <el-image @click="openXx1()"
                            :src="require('../img2/gongan.png')"
                    ></el-image>
                    <el-image @click="openXx2()"
                            :src="require('../img2/shiye.png')"
                    ></el-image>
            </el-row>
        </el-footer>
    </el-container>
</template>
<script>
    import Test from "../views/test";
    export default {
        name: 'commen_home',
        components: {Test},
        data () {
            const activeIndex = this.$route.query.id;
            return {
                xmmc:'',
                msg: 'layout',
                activeIndex,
                sfxs_test:this.$route.path.indexOf("spfhome") != -1?false:true,
            }
        },
        provide(){
            return {
                resrtActityIndex:this.resrtActityIndex
            }
        },
        beforeCreate(){
            console.log(this.$route.query.id)
        },
        methods: {
            warnMessage(obj) {
                this.$alert(obj, '温馨提示', {
                    confirmButtonText: '确定',
                });
            },
            WarnMessageZl(){
                this.warnMessage("功能正完善中...");
            },
            handleClick(tab, event) {
                console.log(tab, event);
            },
            resrtActityIndex(obj){
                this.activeIndex = obj;
            },
            menuClick(obj) {
                if(obj.indexOf("spfhome") != -1){
                    this.sfxs_test=false;
                }else{
                    this.sfxs_test=true;
                }
            },
            openXx1() {
                window.location.href ='http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=61070202000162&token=09bf660a-708f-4e07-b1ab-180e7ee94677';
            },
            openXx2() {
                window.location.href ='http://bszs.conac.cn/sitename?method=show&id=0DC17029E39D7C37E053022819ACC01A';
            },
            openByXmmc(){
                this.$router.push({path:'/ywhome/spfhome/SearchXmxx',query:{xmmc:this.xmmc}})
            },
        }
    };
</script>
<style scoped>
    @media screen and (min-width: 414px) {
        ul{
            font-weight:bold;
            display: flex;
            justify-content: center;
        }
        li{
            margin-right: 35px !important;
        }
    }
</style>
<style>
    /*移动端*/
    @media screen and (max-width: 414px) {
        .imgTop{
            height: 59px;
        }
        .el-menu-item {
            width: 25%;
        }
        .mainRoute{
            margin-top: 0px;
        }
        .clfInput img{
            height: 23px;
            width: 30px;
            margin-top:3px;
            margin-left: 10px;
        }
        /*存量房*/
        .clfInput {
            margin-top: -42px;
            margin-left: 220px;
            width: 100%;
            position: absolute;
        }
        .ssInput .el-input__inner{
            height: 25px;
            margin: auto;
            font-size: xx-small;
            margin-left:-15px;
            width: 130%;
        }
        .YeJiao{
            height: 210px !important;
        }
    }
    .el-menu-demo .el-li{
        height: 60px !important;
        sline-height: 60px !important;
    }
    .HeadLog .el-image{
        float: left;
    }
    /*PC端*/
    @media screen and (min-width: 414px) {

        .imgTop{
            height: 119px;
        }
        .el-menu--horizontal>.el-menu-item{
            width: 111px;
        }
        .clfInput img{
            height: 60px;
        }
        /*存量房*/
        .clfInput {
            margin-top: -90px;
            margin-left: 55%;
            width: 100%;
            position: absolute;
        }

        .ssInput .el-input__inner{
            height: 60px;
            margin: auto;
        }
    }
    .imgTop{
        display: flex;
    }
    .v-application p {
         margin-bottom: 0;
    }
    .el-menu--horizontal>.el-menu-item{
        border-bottom: none !important;
    }
    .el-menu--horizontal>.is-active{
        background-color: #005fc3 !important;
    }

    .el-image__inner--center{
        top:0 !important;
        left:0 !important;
        transform:none !important;
    }
</style>
<style scoped>
    .el-footer {
        background-color: #333333;
        color: #FFFFFF;
        text-align: center;
        font-size: 13px;
        line-height: 28px;
    }
    .el-header{
        height: auto !important;
        padding: 0 !important;
    }
    .el-table .warning-row {
        background: oldlace;
    }

    .el-table .success-row {
        background: #f0f9eb;
    }
    .footClass{
        margin-top: 3%;
    }
</style>